import React from 'react';
import { Route } from 'react-router-dom';

import SignInPage from './Auth/SignInPage';
import SignUpPage from './Auth/SignUpPage';
import ForgotPage from './Auth/ForgotPage';
import RecoveryPage from './Auth/RecoveryPage';
import JsonTestTable from './TabePage';

export default class UnauthorizedRouter extends React.Component {
  componentDidMount() {
    document.body.classList.add('auth-bg');
  }

  componentWillUnmount() {
    document.body.classList.remove('auth-bg');
  }

  render() {
    return (
      <div>
        <Route exact path="/sign_in" component={SignInPage} />
        <Route exact path="/sign_up" component={SignUpPage} />
        <Route exact path="/forgot" component={ForgotPage} />
        <Route exact path="/password-recovery" component={RecoveryPage} />
        <Route exact path="/json-table" component={JsonTestTable} />
      </div>
    );
  }
}
